"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var SidebarService = (function () {
    function SidebarService() {
        this._openObserver = new Subject_1.Subject();
        this._closeObserver = new Subject_1.Subject();
    }
    SidebarService.prototype.open = function () {
        this._openObserver.next();
    };
    SidebarService.prototype.close = function () {
        this._closeObserver.next();
    };
    SidebarService.prototype.onOpen = function (fn) {
        return this._openObserver.subscribe(fn);
    };
    SidebarService.prototype.onClose = function (fn) {
        return this._closeObserver.subscribe(fn);
    };
    return SidebarService;
}());
SidebarService.decorators = [
    { type: core_1.Injectable },
];
/** @nocollapse */
SidebarService.ctorParameters = function () { return []; };
exports.SidebarService = SidebarService;



//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/~/ng-sidebar/lib/sidebar.service.js
// module id = ../../../../ng-sidebar/lib/sidebar.service.js
// module chunks = 9